export default __webpack_public_path__ + "static/media/teacher.347c0d79.png";